import { render, staticRenderFns } from "./PortalPopup.vue?vue&type=template&id=6932832c&scoped=true"
import script from "./PortalPopup.vue?vue&type=script&lang=js"
export * from "./PortalPopup.vue?vue&type=script&lang=js"
import style0 from "./PortalPopup.vue?vue&type=style&index=0&id=6932832c&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6932832c",
  null
  
)

export default component.exports